'use client'

import { useState } from 'react'

import { useKeenSlider } from 'keen-slider/react'
import { KeenSliderArrows } from '@/components/keen-slider/KeenSliderPlugins'
import 'keen-slider/keen-slider.min.css'

import DetailsCard from '../details-card/DetailsCard'

export default function People({ people, slider = false }) {
  // Bail if no people
  if (!people || !people.length) {
    return null
  }

  const peopleGridClass = `
    grid
    w-full
    grid-cols-1
    items-start
    gap-s
    s-up:grid-cols-2
    ms-up:gap-m
    m-up:grid-cols-3
  `

  const singleTemplateClass = `
    @[0px]/single:!grid-cols-1
    @[600px]/single:!grid-cols-2
  `

  const nestedFlexClass = `
    @[0px]/nested-flex:grid-cols-1
    @[600px]/nested-flex:!grid-cols-2
  `

  return (
    <div className="component">
      <div
        className={`container ${slider ? '' : '@[0px]/single-simple:!max-w-[var(--container-s-max-w)]'}`}>
        {slider ? (
          <PeopleSlider people={people} />
        ) : (
          <div className={`${peopleGridClass} ${singleTemplateClass} ${nestedFlexClass}`}>
            {people.map((item, index) => {
              return (
                <DetailsCard
                  key={index}
                  image={item?.image}
                  title={item?.name}
                  subtitle={item?.job_title}
                  text={item?.bio}
                  email={item?.email}
                  link={{
                    url: item?.link,
                    title: 'Profile',
                  }}
                />
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export function PeopleSlider({ people }) {
  const [isDisabled, setIsDisabled] = useState(false)

  const [sliderRef, instanceRef] = useKeenSlider({
    initial: 0,
    slides: {
      perView: 1,
      spacing: 24,
    },
    breakpoints: {
      '(min-width: 600px)': {
        slides: {
          perView: 2,
          spacing: 16,
        },
      },
      '(min-width: 990px)': {
        slides: {
          perView: 3,
          spacing: 24,
        },
      },
    },
    created(s) {
      setIsDisabled(s.options.disabled)
    },
    detailsChanged(s) {
      setIsDisabled(s.options.disabled)
    },
  })

  if (!people || people.length === 0) {
    return null
  }

  return (
    <div className="w-full">
      <div ref={sliderRef} className={`keen-slider`}>
        {people.map((item, index) => {
          return (
            <div className="keen-slider__slide" key={index}>
              <DetailsCard
                key={index}
                image={item?.image}
                title={item?.name}
                subtitle={item?.job_title}
                text={item?.bio}
                email={item?.email}
                link={{
                  url: item?.link,
                  title: 'Profile',
                }}
              />
            </div>
          )
        })}
      </div>

      <KeenSliderArrows sliderInstance={instanceRef} disabled={isDisabled} />
    </div>
  )
}
